import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Pagination extends Vue {
  @Prop({ default: '' }) customLabel: string;
  @Prop({ default: 10 }) itemsPerPage: number;
  @Prop({ default: 0 }) pageCount: number;

  private currentPage = 1;
  private rowsPerPage = 5;

  private itemsPerPageOptions = [
    { text: 5, value: 5 },
    { text: 10, value: 10 },
    { text: 15, value: 15 },
    { text: 'All', value: -1 }
  ];

  onPageChange(): void {
    this.$emit('onPageChange', this.currentPage);
  }

  onItemsPerPageChange(): void {
    this.$emit('onItemsPerPageChange', this.rowsPerPage);
    this.currentPage = 1;
  }

  created(): void {
    this.rowsPerPage = this.itemsPerPage;
  }
}
